<template>
  <div style="background-color: white">
    <v-list-item three-line>
      <v-list-item-avatar
        tile
        size="40"
      >
        <v-icon color="primary">
          info
        </v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title v-text="datas.client_civilite + ' ' + datas.client_nom + ' ' + datas.client_prenom" />
        <v-list-item-subtitle
          v-if="datas.client_telephone"
          v-text="datas.client_telephone"
        />
        <v-list-item-subtitle
          v-if="datas.client_email"
          v-text="datas.client_email"
        />
      </v-list-item-content>
      <v-menu
        bottom
        origin="center center"
        transition="scale-transition"
      >
        <template v-slot:activator="{ on }">
          <fx-icon
            :size="30"
            color="primary"
            icon="menu"
            tooltip="Menu des actions"
            v-on="on"
          />
        </template>
        <v-list>
          <v-list-item
            v-if="datas.client_telephone"
            @click="f_appeler(datas.client_telephone)"
          >
            <v-list-item-avatar>
              <v-icon color="primary">
                phone
              </v-icon>
            </v-list-item-avatar>
            <v-list-item-title>Appeler : {{ datas.client_telephone }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="datas.client_email"
            @click="f_mail(datas.client_email)"
          >
            <v-list-item-avatar>
              <v-icon color="primary">
                mail
              </v-icon>
            </v-list-item-avatar>
            <v-list-item-title>Ecrire : {{ datas.client_email }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-list-item>
  </div>
</template>

<script>
export default {
    name: 'CxInterventionInfosGenerale',
    props: {
        datas: {
            type: Object,
            default: null,
        },
    },
    methods: {
        f_appeler (valeur) {
            window.location = 'tel:' + valeur
        },
        f_mail (valeur) {
            window.location = 'mailto:' + valeur
        },
    },
}
</script>

<style scoped>

</style>